import CRMProLayoutLayout from '@/modules/cmr-pro/layout/CrmProLayout.vue';

const routes = [
  {
    path: 'person-account',
    name: 'crm-pro-person-account',
    component: () =>
      import('@/modules/cmr-pro/views/PersonAccountInformation.vue')
  },
  {
    path: 'person-account/person/:id',
    name: 'crm-pro-person-account-person-id',
    component: () => import('@/modules/cmr-pro/views/UpdatePerson.vue')
  },
  {
    path: 'person-account/account/:id',
    name: 'crm-pro-person-account-account-id',
    component: () => import('@/modules/cmr-pro/views/UpdateAccount.vue')
  }
];

export default {
  path: 'app/customer-management',
  name: 'crm-pro',
  component: CRMProLayoutLayout,
  redirect: {
    name: 'crm-pro-person-account'
  },
  meta: {
    requiresAuth: true,
    requiredPrivileges: ['Process Customer']
  },
  children: [...routes]
};
